<template>
    <div id="app" :class="[{'user-connected': isUserConnected, 'app-loaded': !$store.state.initialLoading, 'app-ready': $store.state.applicationReady, 'embed': isEmbed}]">
        <div id="app-container">
            <router-view @login-start="loginStart" @login-finished="loginFinished"/>
        </div>
        <cookie-law theme="dark-lime" :button-text="'Accept|Accepter'|tr">
            <template #message>
                <span v-tr>
                    This website uses cookies to ensure you get the best experience on our website.|
                    Ce site internet utilise des cookies pour vous garantir la meilleure expérience.
                </span>
            </template>
        </cookie-law>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import moment from "moment"
    import CookieLaw from 'vue-cookie-law'
    import VueCookies from 'vue-cookies'

    import {getLanguage, translate} from "../vue-components/helpers/i18n"

    export default {
        name: `App`,
        metaInfo: {
            title: translate(`Digital Signage, Restaurant Menuboards, Self-Ordering, Guest WiFi|Affichage et Menus Numériques, Commande Autonome, WiFi Public`),
            titleTemplate: `%s | Eye-In Media`
        },
        components: { CookieLaw },
        data() {
            return {
                ready: true // True by default except on the login vue
            };
        },
        created() {
            this.$store.commit(`setWebpSupport`);

            if (this.$route.query) {
                if (this.$route.query.lang) {
                    this.$store.commit(`setLanguage`, this.$route.query.lang);
                }

                for (let key in this.$route.query) {
                    if (key.startsWith(`utm_`)) {
                        VueCookies.set(`${key}`, this.$route.query[key]);
                    }
                }
            }

            this.onWindowResize();
            window.addEventListener(`resize`, this.onWindowResize);

            const language = getLanguage();
            moment.locale(language);
            if (this.$route.fullPath === `/login`) {
                this.$store.dispatch(`logout`);
            } else {
                // try to get the current user with the saved token
                this.$store.dispatch(`getCurrentUser`).then(() => {
                    this.$store.state.initialLoading = false;

                    // Allow to provide a smooth transition when opening a new tab, but add nice effect after when user disconnect
                    setTimeout(() => {
                        this.$store.state.applicationReady = true;
                    }, 1000);
                });
            }
        },
        mounted() {
            setTimeout(() => {
                gtag(`event`, `page_view`, {
                    page_path: window.location.path,
                    page_location: window.location.href,
                    page_title: document.title
                });
            }, 150);
        },
        computed: {
            isUserConnected() {
                return this.ready === true && this.$store.getters.isAuthenticated;
            },
            isEmbed() {
                return this.$route.query.embed === `true`;
            },
            ...mapGetters([
                `isAuthenticated`
            ])
        },
        methods: {
            loginStart() {
                this.ready = false;
            },
            loginFinished() {
                this.ready = true;
            },
            getLayoutWidth() {
                return window.getLayoutWidth();
            },
            onWindowResize() {
                this.$store.state.isMobileLayout = window.isMobileLayout;
                this.$store.state.isSmallLayout = window.isSmallLayout;
                this.$store.state.isMobileOrTabletLayout = window.isMobileOrTabletLayout;
                this.$store.state.isLargeLayout = window.isLargeLayout;
                this.$store.state.isExtraLargeLayout = window.isExtraLargeLayout;
            }
        }
    }
</script>

<style lang="scss">
    @import "assets/style/global.scss";

    html,
    body {
        margin: 0;
        padding: 0;
        width: 100%;
        min-height: 100%;
        height: 100%;
        background: #151e28;
    }

    #app,
    #app-container {
        width: 100%;
        height: 100%;
    }

    .Cookie {
        background-color: rgba(0, 0, 0, 0.85);

        &.Cookie--bottom {
            padding: 7px 14px;
            max-width: 400px;
            left: auto;

            .Cookie__content {
                margin: 0;
                font-size: 10pt;
            }

            .Cookie__buttons {
                margin: 0;

                .Cookie__button {
                    border-radius: 50px;
                    font-size: 10pt;
                    padding: 7px 30px;
                    color: #383f30;
                }
            }
        }

        @media (max-width: 576px) {
            text-align: center;
            max-width: none;

            .Cookie__content {
                margin: 0;
                font-size: 9pt;
            }

            .Cookie__buttons {
                margin: 5px 0 0;

                .Cookie__button {
                    font-weight: 600;
                    padding: 5px 30px;
                }
            }
        }
    }
</style>
